import React, { useState, useContext } from 'react';
import { connect } from 'react-redux';
import { AuthContext } from '../../context/AuthContext';
import DownloadReportsBlock from '../DownloadReportsBlock/index.store'

import ButtonSecondary from '../ui/ButtonSecondary';
import BaseForm from '../BaseForm';

import { updateDealer } from '../../store/actions';

import {
  REQUIRED,
  EMAIL,
  PHONE
} from '../../utils/formValidation';

import './index.css';

const DealerDetails = (props) => {
  const {role} = useContext(AuthContext);
  const [formValues] = useState({
    UUID: props.dealer.UUID,
    name: props.dealer.name,
    brand: props.dealer.brand,
    address: props.dealer.address,
    zip: props.dealer.zip,
    email: props.dealer.email,
    phone: props.dealer.phone,
  });

  const isDeleteAvailable = role === 'admin' && props.dealer.status !== 'deleted';

  const formData = [
    {
      name: 'name',
      labelName: 'Company',
      type: 'text',
      validation: [REQUIRED]
    },
    {
      name: 'brand',
      labelName: 'Auto Make',
      type: 'text',
      validation: [REQUIRED]
    },
    {
      name: 'address',
      labelName: 'Street Address',
      type: 'text',
      validation: [REQUIRED]
    },
    {
      name: 'zip',
      labelName: 'Zip',
      type: 'text',
      validation: [REQUIRED]
    },
    {
      name: 'email',
      labelName: 'Email',
      type: 'text',
      validation: [REQUIRED, EMAIL]
    },
    {
      name: 'phone',
      labelName: 'Phone',
      type: 'text',
      validation: [REQUIRED, PHONE]
    },
    // {
    //   name: 'contact',
    //   labelName: 'Contact',
    //   type: 'text',
    //   validation: []
    // },
  ];

  const summaryFormData = [
    {
      name: 'bins',
      labelName: 'Bins',
      type: 'text',
      readOnly: true,
    },
    {
      name: 'parts',
      labelName: 'Parts',
      type: 'text',
      readOnly: true,
    },
    {
      name: 'quantity',
      labelName: 'Quantity',
      type: 'text',
      readOnly: true,
    }
  ]

  const actionsData = {
    other: data => props.updateDealer({
      name: data.name,
      brand: data.brand,
      address: data.address,
      zip: data.zip,
      phone: data.phone,
      email: data.email
    }, props.dealer.UUID),
  }

  return (
    <div className="dealer-details">
    <BaseForm
      readOnly={role !== 'admin'}
      title="Dealer info"
      formData={formData}
      initialData={formValues}
      actionsData={actionsData}
    />
    {props.summary &&
      <BaseForm
        readOnly={true}
        formOnly={true}
        formData={summaryFormData}
        initialData={props.summary}
      />
    }
      <DownloadReportsBlock title='Dealer Reports'/>
    { isDeleteAvailable &&
      <div className="dealer-details__form-group job-details__controls">
        <ButtonSecondary name="Delete Dealer" onClick={props.onDeleteDealer}/>
      </div>
    }
    </div>
  );
}

export default connect(null, { updateDealer })(DealerDetails);
